import { sentryLogger } from '../monitor/monitor';
import { createHttpClient } from '../utils/httpUtils';

class SubcontractService {
  constructor() {
    this.http = createHttpClient();
  }

  async show(subContractId) {
    const res = await this.http
      .get('subcontracts/' + subContractId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async destroy(subContractId) {
    const res = await this.http
      .delete('subcontracts/' + subContractId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async create(data) {
    const res = await this.http.post('subcontracts', data).catch((error) => {
      console.log(error.response);
      return false;
    });
    return res ? res.data : res;
  }

  async assignToProject(data) {
    const res = await this.http
      .post('subcontracts/assign-project', data)
      .catch((error) => console.error(error.response));
    return res?.data || res;
  }

  async update(data) {
    const res = await this.http
      .put('subcontracts/' + data.id, data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  /**
   * @deprecated This method will be removed in future versions.
   * Use getByProjectSettings() instead
   */
  async showByProject(projectId) {
    const res = await this.http
      .get('subcontracts/project/' + projectId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  /**
   * @deprecated This method will be removed in future versions.
   * Use getByOrganizationSettings() instead.
   */
  async getByCompany(organizationId) {
    const res = await this.http
      .get('subcontracts/company/' + organizationId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async getByOrganizationSettings() {
    try {
      const { data: responseData } = await this.http.get(
        `subcontracts/settings/organization`
      );
      return responseData;
    } catch (error) {
      sentryLogger.error('getByOrganizationSettings', { error });
      throw error;
    }
  }

  async getByProjectSettings(projectId) {
    try {
      const { data: responseData } = await this.http.get(
        `subcontracts/settings/project/${projectId}`
      );
      return responseData;
    } catch (error) {
      sentryLogger.error('getByProjectSettings', { error });
      throw error;
    }
  }

  /**
   * @deprecated This method will be removed in future versions.
   * Use getByProjectSettings() instead.
   */
  async getByProject(projectId) {
    const res = await this.http
      .get('subcontracts/byproject/' + projectId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }
}

export const subContractService = new SubcontractService();
